import { cms } from '$lib/CMS';
import { error } from '@sveltejs/kit';
import type { PageLoad } from './$types';

export const load: PageLoad = (async ({ params }) => {
	const response = await cms.getContentPage(params.slug);
	if (!response.success) {
		throw response.error;
	}

	if (!response.data.contentPage) {
		error(404, {
			message: `Content page with slug "${params.slug}" not found`
		});
	}

	return {
		page: response.data.contentPage
	};
}) satisfies PageLoad;
